import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdSlot({ slot, className = "" }) {
  const [ads, setAds] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/ads?slot=${slot}&active=true`);
        setAds(data);
      } catch {}
    })();
  }, [slot]);

  if (!ads.length) return null;
  const ad = ads[0]; // Show first active ad for slot

  const handleClick = () => {
    api.post(`/ads/${ad.id}/click`).catch(() => {});
  };

  return (
    <a
      href={ad.link_url}
      target="_blank"
      rel="noreferrer sponsored"
      onClick={handleClick}
      className={`block relative group ${className}`}
      data-testid={`ad-slot-${slot}`}
    >
      <div className="absolute top-2 left-2 z-10 bg-background/90 text-foreground text-[9px] uppercase tracking-widest font-bold px-2 py-0.5 rounded-sm border border-border">
        Ad
      </div>
      <img
        src={ad.image_url}
        alt={ad.title}
        className="w-full h-full object-cover rounded-sm border border-border group-hover:opacity-95 transition-opacity"
      />
    </a>
  );
}
